import {
  List,
  Datagrid,
  TextField,
  DateField,
  TextInput,
  ImageField,
  BooleanField,
  SelectInput,
  ReferenceInput,
  ShowButton,
} from 'react-admin';

const offerFilters = [
  <TextInput key='name' label='Name' source='name' alwaysOn />,
  <ReferenceInput key='statusId' source='statusId' reference='offer-options' filter={{ type: 'offerStatus' }}>
    <SelectInput label='Offer Status' optionText='name' />
  </ReferenceInput>,
  <ReferenceInput key='offerTypeId' source='offerTypeId' reference='offer-options' filter={{ type: 'offerType' }}>
    <SelectInput label='Offer Type' optionText='name' />
  </ReferenceInput>,
  <ReferenceInput key='industryId' source='industryId' reference='offer-options' filter={{ type: 'offerIndustry' }}>
    <SelectInput label='Industry' optionText='name' />
  </ReferenceInput>,
  <ReferenceInput key='categoryId' source='categoryId' reference='offer-options' filter={{ type: 'offerCategory' }}>
    <SelectInput label='Category' optionText='name' />
  </ReferenceInput>,
  <ReferenceInput
    key='securityTypeId'
    source='securityTypeId'
    reference='offer-options'
    filter={{ type: 'offerSecurityType' }}>
    <SelectInput label='Security type' optionText='name' />
  </ReferenceInput>,
];

const OfferList = () => (
  <List title='Offers' filters={offerFilters} sort={{ field: 'createdAt', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false}>
      <ImageField
        label='Logo'
        source='logoUrl'
        sx={{ '& img': { maxHeight: '4rem', objectFit: 'contain', margin: '0.25rem' } }}
      />
      <TextField source='name' />
      <TextField source='status' label='Status' sortable={false} />
      <TextField source='type' label='Type' sortable={false} />
      <TextField source='industry' label='Industry' sortable={false} />
      <TextField source='category' label='Category' sortable={false} />
      <TextField source='security' label='Security' sortable={false} />
      <BooleanField source='visibleToEndUsers' label='Visible' />
      <BooleanField source='new' />
      <BooleanField source='featured' />
      <BooleanField source='isExternalOffer' label='Is external' />
      <BooleanField source='recurring' />
      <DateField source='startDate' sortable={false} />
      <TextField source='closeDate' sortable={false} />
      <DateField source='createdAt' label='Created At' />
      <ShowButton label='Show' />
    </Datagrid>
  </List>
);

export default OfferList;
